<lib-loader *ngIf="showLoader"></lib-loader>

<div id="item-info-setup-details-popup" class="item-info-popup" fxLayout="column">
    <lib-popup-header
        [title]="dataSource ? dataSource.item + ' — ' + dataSource.itemDescriptionLN : (data.item || data.itemCode || 'Item information')"
        [isMaximized]="data.isMaximized"
        (isPopupMaximized)="setGridHeight($event)">
    </lib-popup-header>

    @if (loadFailed) {
    <div class="item-info-popup__body item-info-popup__error" role="alert">
        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
        <div>
            <div class="item-info-popup__error-title">The item information could not be loaded.</div>
            <div>Close this window and try again later. If it keeps happening, contact support.</div>
        </div>
    </div>
    } @else {
    <div class="item-info-popup__body">
        <form [formGroup]="itemInfoSetupForm" class="item-info-popup__layout">
            <section class="item-info-popup__product">
                <div class="image-section">
                    <img
                        id="placeholder"
                        class="item-info-popup__image"
                        [src]="dataSource?.imageURL ? $safeNavigationMigration(dataSource?.imageURL) : blankImage"
                        [alt]="dataSource?.itemDescriptionLN || dataSource?.item">
                </div>

                <div class="item-info-popup__description">
                    <label class="field-label">LN description</label>
                    <div>{{dataSource?.itemDescriptionLN}}</div>
                </div>
                <div class="item-info-popup__description">
                    <label class="field-label">Description</label>
                    <div>{{dataSource?.itemDescription}}</div>
                </div>
            </section>

            <section class="item-info-popup__specifications">
                <label class="field-label item-info-popup__section-title">Product specifications</label>
                <ejs-textarea
                    maxLength="3000"
                    [readonly]="true"
                    [disabled]="true"
                    class="bordered item-info-popup__specification-input"
                    placeholder="Write description here ..."
                    formControlName="productSpecification"
                    resizeMode="None"
                    rows="16"
                    cols="140">
                </ejs-textarea>
            </section>

            <section class="item-info-popup__details">
                <div class="item-info-popup__field">
                    <label class="field-label">Channel(s)</label>
                    <div class="item-info-popup__pills">
                        @for(channel of (showAllChannels ? channelPills : channelPills.slice(0, 5)); track $index) {
                        <span class="item-info-popup__pill">{{channel}}</span>
                        }
                        @if(channelPills.length === 0) {
                        <span class="item-info-popup__empty-link">No channels selected</span>
                        }
                        @if(channelPills.length > 5) {
                        <button
                            type="button"
                            class="item-info-popup__pill-toggle"
                            [attr.aria-expanded]="showAllChannels"
                            (click)="showAllChannels = !showAllChannels">
                            {{showAllChannels ? 'Show less' : 'Show more'}}
                        </button>
                        }
                    </div>
                    <span
                        class="error_control error-tooltip"
                        *ngIf="itemInfoSetupForm?.controls['channel']?.touched && itemInfoSetupForm?.controls?.channel?.errors?.required">
                        Channel is required
                    </span>
                </div>

                <div class="item-info-popup__field">
                    <label class="field-label">Account(s)</label>
                    <div class="item-info-popup__pills">
                        @for(account of (showAllAccounts ? accountPills : accountPills.slice(0, 5)); track $index) {
                        <span class="item-info-popup__pill">{{account}}</span>
                        }
                        @if(accountPills.length === 0) {
                        <span class="item-info-popup__empty-link">No accounts selected</span>
                        }
                        @if(accountPills.length > 5) {
                        <button
                            type="button"
                            class="item-info-popup__pill-toggle"
                            [attr.aria-expanded]="showAllAccounts"
                            (click)="showAllAccounts = !showAllAccounts">
                            {{showAllAccounts ? 'Show less' : 'Show more'}}
                        </button>
                        }
                    </div>
                    <span
                        class="error_control error-tooltip"
                        *ngIf="itemInfoSetupForm?.controls['account']?.touched && itemInfoSetupForm?.controls?.account?.errors?.required">
                        Account is required
                    </span>
                </div>

                <div class="item-info-popup__links">
                    <div class="item-info-popup__link-row" id="pdf-upload">
                        <i class="fas fa-file-alt item-info-popup__link-icon" aria-hidden="true"></i>
                        <div class="item-info-popup__link-content">
                            <span class="item-info-popup__link-label">Brochure</span>
                            @if(dataSource?.brochure) {
                            <a (click)="downloadFile(tempUrl ? tempUrl : dataSource.brochureURL)">
                                {{dataSource?.brochure}}
                            </a>
                            } @else {
                            <span class="item-info-popup__empty-link">No brochure available</span>
                            }
                        </div>
                    </div>

                    <div class="item-info-popup__link-row">
                        <i class="fas fa-link item-info-popup__link-icon" aria-hidden="true"></i>
                        <div class="item-info-popup__link-content">
                            <span class="item-info-popup__link-label">Flyer</span>
                            @if(dataSource?.flyerURL?.trim()?.length) {
                            <a
                                target="_blank"
                                (click)="openInNewTab($event, 'flyer')"
                                [href]="itemInfoSetupForm.get('flyerURL').value ?? ''"
                                [title]="itemInfoSetupForm.get('flyerURL').value">
                                {{itemInfoSetupForm.get('flyerURL').value}}
                            </a>
                            } @else {
                            <span class="item-info-popup__empty-link">No flyer available</span>
                            }
                        </div>
                    </div>

                    <div class="item-info-popup__link-row">
                        <i class="fas fa-globe item-info-popup__link-icon" aria-hidden="true"></i>
                        <div class="item-info-popup__link-content">
                            <span class="item-info-popup__link-label">Product page</span>
                            @if(dataSource?.productURL?.trim()?.length) {
                            <a
                                target="_blank"
                                [href]="itemInfoSetupForm.get('productURL').value ?? ''"
                                (click)="openInNewTab($event, 'product')"
                                [title]="itemInfoSetupForm.get('productURL').value">
                                {{itemInfoSetupForm.get('productURL').value}}
                            </a>
                            } @else {
                            <span class="item-info-popup__empty-link">No product page available</span>
                            }
                        </div>
                    </div>
                </div>
            </section>
        </form>
    </div>
    }

    <footer class="item-info-popup__footer">
        <button type="button" class="btn btn-sm btn-danger" (click)="onCloseClick()">Close</button>
    </footer>
</div>
